import { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function UpdatePassword() {
  const [password, setPassword] = useState('');
  const [checkingSession, setCheckingSession] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (active && session) {
        setCheckingSession(false);
      }
    });

    supabase.auth.getSession().then(({ data }) => {
      if (!active) return;

      if (data.session) {
        setCheckingSession(false);
        return;
      }

      // El link de recuperación puede tardar un instante en procesarse antes de
      // que la sesión quede disponible, así que esperamos un poco antes de
      // asumir que no hay una recuperación en curso.
      setTimeout(() => {
        supabase.auth.getSession().then(({ data: retryData }) => {
          if (!active) return;
          if (retryData.session) {
            setCheckingSession(false);
          } else {
            navigate('/login');
          }
        });
      }, 1000);
    });

    return () => {
      active = false;
      subscription.unsubscribe();
    };
  }, [navigate]);

  const handleUpdate = async () => {
    const { error } = await supabase.auth.updateUser({
      password,
    });

    if (error) {
      alert(error.message);
    } else {
      alert('Contraseña actualizada!');
      navigate('/login');
    }
  };

  if (checkingSession) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <p className="text-ink/60">Verificando enlace…</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <div className="bg-card border border-sand p-6 rounded-[4px_60px_4px_60px] shadow-lg w-96">
        <h2 className="text-xl font-serif text-terracotta mb-4">Nueva contraseña</h2>

        <input
          type="password"
          placeholder="Nueva contraseña"
          className="border border-sand bg-cream w-full px-3 py-2 mb-4 rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button onClick={handleUpdate} className="bg-terracotta hover:bg-terracotta-dark text-cream px-4 py-2 rounded-full w-full transition">
          Cambiar contraseña
        </button>
      </div>
    </div>
  );
}
